
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';

const ContactUs = () => {

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                
                <p className={formStyles['text-center']}>
                    ارتباط با ما 
                </p>

                <p className={formStyles['text-center']}>
                    تلفن ها:
                    <br />
                    <a href="tel:+987136364893">071-36364893</a>
                    <br />
                    (6 خط سانترال)
                </p>

                <p className={formStyles['text-center']}>
                    پشتیبانی:
                    <br />
                    <a href="tel:+989020843320">09020843320</a>
                </p>

                <p className={formStyles['text-center']}>
                    ایمیل مدیر عامل جهت ارتباط مستقیم:
                    <br />
                    <a href="mailto:dr20consult@gmail.com">dr20consult@gmail.com</a>
                </p>

                <p className={formStyles['text-center']}>
                    آدرس سایت اصلی: 
                    <br />
                    www.dr20.org
                </p>

                <p className={formStyles['text-center']}>
                    آدرس وب سایت های اکسسوری:
                    <br />
                    <a href="https://dr20.education" target="_blank">www.dr20.education</a>
                    <br />
                    <a href="https://dr20.net" target="_blank">www.dr20.net</a>
                    <br />
                    <a href="https://dr20.info" target="_blank">www.dr20.info</a>
                    <br />
                    <a href="https://dr20.shop" target="_blank">www.dr20.shop</a>
                    <br />
                    <a href="https://dr20.biz" target="_blank">www.dr20.biz</a>
                    <br />
                    <a href="https://dr20.app" target="_blank">www.dr20.app</a>
                </p>

                <p className={formStyles['text-center']}>
                    آدرس پیج اینستاگرام فارسی:
                    <br />
                    <a href="https://instagram.com/dr20_org" target="_blank">www.instagram.com/dr20_org</a>
                </p>

                <p className={formStyles['text-center']}>
                    آدرس پیج اینستاگرام اینترنشنال
                    <br />
                    <a href="https://instagram.com/dr20_int" target="_blank">www.instagram.com/dr20_int</a>
                </p>

            </div>
                
        </div>

    );
}

export default ContactUs;